import "./Team.css";
import TeamCard from "./TeamCard";
const Team = () => {
  return (
    <div id="team">
      <h1 className="fw-bold text-center" data-aos="fade-down">
        {" "}
        Who is with me
      </h1>

      <div className="container">
        {" "}
        <div className="row mx-auto w-100">
          <TeamCard />
        </div>
      </div>
    </div>
  );
};

export default Team;
